module.exports = __webpack_public_path__ + "static/media/glucose-bottom.4263b8d9.png";